import styled from 'styled-components';

// Styles
const FilterWrapper = styled.div`
  .rw-placeholder {
    color: black;
  }
  .rw-list-empty {
    padding: 0;
  }
  .rw-list {
    max-height: inherit;
  }
  .select-field {
    margin-bottom: 0;
  }
`;

const CustomList = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0;
`;

const CustomItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 1em;
  transition: background 0.25s ease-in-out;
  position: relative;
  cursor: pointer;
  text-transform: capitalize;
  &:hover {
    background: #ececec;
  }
  p {
    flex: 1; /* fix IE bug */
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    display: block;
    width: 34px;
    height: 14px;
    background: ${(p) => p.theme.color.bg_switcher};;
    border-radius: 7px;
    position: relative;
    margin: 0 1em;
    transition: all 0.25s ease-in-out;
    &:after {
      transition: all 0.25s ease-in-out;
      display: block;
      content: '';
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: ${(p) => p.theme.color.primary};
      transform: translate(100%, -17%);
    }
  }
  ${props =>
    !props.active &&
    `
    color: ${props.theme.color.label};
    span {
    background: #f5f5f9;
    &:after {
      transform: translate(0%, -17%);
      background: ${(p) => p.theme.color.disabled};
    }
  }`};
  ${props =>
    props.bottomLine &&
    `&:after {
    display: block;
    content: '';
    width: 100%;
    position: absolute;
    height: 1px;
    background: ${props.theme.color.border};
    bottom: 0;
    left: 0;
  }`};
`;

const ValueItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em;
  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding-left: 0.8em;
  }
`;

export default {
  FilterWrapper,
  CustomList,
  CustomItem,
  ValueItemWrapper
};
